// // import { useEffect, useState, useRef } from "react";
// // import { 
// //   GetDataFromApiWithParams, 
// //   ExecutePostWithParams 
// // } from "../../../../services/api/ExecuteApiRequests";
// // import IPDCFinalTable from "../../../../components/IPDCFinalTable";
// // import { Box, Button, Alert, CircularProgress, Typography, Card, CardContent } from "@mui/material";
// // import { Check, Close, Download, TableChart } from "@mui/icons-material";

// // export default function AgreementVerificationPage() {
// //   const [agreements, setAgreements] = useState([]);
// //   const componentRef = useRef();
// //   const [selectedColumns, setSelectedColumns] = useState([]);
// //   const [loading, setLoading] = useState(true);
// //   const [error, setError] = useState("");
// //   const [success, setSuccess] = useState("");

// //   useEffect(() => {
// //     fetchPendingAgreements();
// //   }, []);

// //   // Helper function to process JSON fields
// //   const processAgreementData = (data) => {
// //     if (!data) return data;
    
// //     return data.map(item => {
// //       const processedItem = { ...item };
      
// //       // Handle late_charge_fee JSON object
// //       if (processedItem.late_charge_fee && typeof processedItem.late_charge_fee === 'object') {
// //         const fee = processedItem.late_charge_fee;
// //         processedItem.late_charge_fee = `${fee.fee || 0}${fee.rate_type || '%'}`;
// //       }
      
// //       // Handle market_destination array
// //       if (Array.isArray(processedItem.market_destination)) {
// //         processedItem.market_destination = processedItem.market_destination.join(', ');
// //       }
      
// //       // Handle intl_brands_link array
// //       if (Array.isArray(processedItem.intl_brands_link)) {
// //         processedItem.intl_brands_link = processedItem.intl_brands_link.join(', ');
// //       }
      
// //       // Handle any other potential JSON fields
// //       if (processedItem.linkage && typeof processedItem.linkage === 'object') {
// //         processedItem.linkage = JSON.stringify(processedItem.linkage);
// //       }
      
// //       return processedItem;
// //     });
// //   };

// //   const fetchPendingAgreements = async () => {
// //     try {
// //       setLoading(true);
// //       setError("");
// //       console.log("Fetching pending agreements from API...");
      
// //       const resultRow = await GetDataFromApiWithParams("agreements/waiting/approval");
// //       console.log("Pending Agreements API Response:", resultRow);
      
// //       if (resultRow && Array.isArray(resultRow)) {
// //         console.log(`Total pending agreements received: ${resultRow.length}`);
        
// //         if (resultRow.length > 0) {
// //           console.log("First pending agreement sample:", resultRow[0]);
          
// //           // Process the data to convert JSON objects to strings
// //           const processedData = processAgreementData(resultRow);
// //           setAgreements(processedData);
          
// //           // Define columns to show
// //           const importantColumns = [
// //             'id', 'agreement_id', 'company_name', 'contact_person', 
// //             'upin', 'investment_type', 'contract_status',
// //             'contract_issued_on', 'contract_period_in_months',
// //             'monthly_rent', 'employee_capacity',
// //             'production_capacity', 'export_capacity', 'security', 'advance_payment',
// //             'tin_no', 'park_name', 'ownership_type', 'payment_mode',
// //             'annual_mngmnt_service_fee', 'grace_period_ending_date', 'market_destination', 'disposal_method',
// //             'handover_date', 'rehandover_date', 'production_commencement_date', 'late_charge_fee'
// //           ];
          
// //           // Use important columns that actually exist in the processed data
// //           const availableColumns = importantColumns.filter(col => 
// //             processedData[0].hasOwnProperty(col)
// //           );
          
// //           console.log("Columns available for display:", availableColumns);
// //           setSelectedColumns([...availableColumns, 'actions']);
// //         } else {
// //           setAgreements([]);
// //           setError("No pending agreements found for approval.");
// //         }
// //       } else {
// //         setError("No agreement data received from API.");
// //       }
// //     } catch (err) {
// //       console.error("Error fetching pending agreements:", err);
// //       setError("Error fetching pending agreements: " + (err.message || "Unknown error"));
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   const handleVerification = async (agreement, action) => {
// //     try {
// //       const agreementId = agreement.id || agreement.agreement_id;
// //       if (!agreementId) {
// //         setError("Cannot verify: Agreement ID is missing");
// //         return;
// //       }

// //       const updateData = {
// //         agreement_id: agreementId,
// //         action: action,
// //         remarks: `Agreement ${action}ed by Operation Management Head`,
// //         verified_by: "operation_management_head",
// //       };

// //       console.log(`Sending ${action} for agreement:`, agreementId);
// //       const response = await ExecutePostWithParams("agreements/approve", updateData);
      
// //       if (response) {
// //         // Remove the verified agreement from the list
// //         setAgreements(prev => prev.filter(item => 
// //           (item.id || item.agreement_id) !== agreementId
// //         ));
// //         setSuccess(`Agreement successfully ${action === "approve" ? "approved" : "rejected"}!`);
// //         setError("");
// //         setTimeout(() => setSuccess(""), 5000);
        
// //         console.log(`Agreement ${agreementId} ${action}ed successfully`);
// //       } else {
// //         setError(`Failed to ${action} agreement. Server returned no response.`);
// //         setSuccess("");
// //       }
// //     } catch (err) {
// //       console.error("Verification error:", err);
// //       setError(`Error: ${err.message || "Unknown error during verification"}`);
// //       setSuccess("");
// //     }
// //   };

// //   const handleExportToExcel = (agreement) => {
// //     try {
// //       // Create a clean copy without React components
// //       const exportData = { ...agreement };
      
// //       // Remove actions
// //       delete exportData.actions;
      
// //       const headers = Object.keys(exportData).filter(key => 
// //         typeof exportData[key] !== 'object' || exportData[key] === null
// //       );
      
// //       const csvHeaders = headers.join(',');
// //       const csvRow = headers.map(header => {
// //         const value = exportData[header];
// //         if (value === null || value === undefined) return '';
// //         // Handle values that might contain commas by wrapping in quotes
// //         return typeof value === 'string' && value.includes(',') ? `"${value}"` : value;
// //       }).join(',');
      
// //       const csvContent = `${csvHeaders}\n${csvRow}`;
      
// //       const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
// //       const link = document.createElement('a');
// //       const url = URL.createObjectURL(blob);
      
// //       link.setAttribute('href', url);
// //       link.setAttribute('download', `agreement_${agreement.id || agreement.agreement_id}_${new Date().toISOString().split('T')[0]}.csv`);
// //       link.style.visibility = 'hidden';
      
// //       document.body.appendChild(link);
// //       link.click();
// //       document.body.removeChild(link);
      
// //       console.log(`Exported agreement ${agreement.id || agreement.agreement_id} to Excel`);
// //     } catch (err) {
// //       console.error("Error exporting to Excel:", err);
// //       setError("Error exporting agreement data to Excel");
// //     }
// //   };

// //   const handleExportAllToExcel = () => {
// //     try {
// //       if (enhancedAgreements.length === 0) {
// //         setError("No data to export");
// //         return;
// //       }

// //       // Create export data without React components
// //       const exportData = enhancedAgreements.map(agreement => {
// //         const cleanData = { ...agreement };
// //         delete cleanData.actions;
// //         return cleanData;
// //       });

// //       const headers = Object.keys(exportData[0]).filter(key => 
// //         typeof exportData[0][key] !== 'object' || exportData[0][key] === null
// //       );
      
// //       const csvHeaders = headers.join(',');
      
// //       const csvRows = exportData.map(item => {
// //         return headers.map(header => {
// //           const value = item[header];
// //           if (value === null || value === undefined) return '';
// //           return typeof value === 'string' && value.includes(',') ? `"${value}"` : value;
// //         }).join(',');
// //       }).join('\n');
      
// //       const csvContent = `${csvHeaders}\n${csvRows}`;
      
// //       const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
// //       const link = document.createElement('a');
// //       const url = URL.createObjectURL(blob);
      
// //       link.setAttribute('href', url);
// //       link.setAttribute('download', `all_pending_agreements_${new Date().toISOString().split('T')[0]}.csv`);
// //       link.style.visibility = 'hidden';
      
// //       document.body.appendChild(link);
// //       link.click();
// //       document.body.removeChild(link);
      
// //       console.log(`Exported all ${enhancedAgreements.length} agreements to Excel`);
// //       setSuccess(`All ${enhancedAgreements.length} agreements exported successfully!`);
// //       setTimeout(() => setSuccess(""), 5000);
// //     } catch (err) {
// //       console.error("Error exporting all to Excel:", err);
// //       setError("Error exporting all agreements data to Excel");
// //     }
// //   };

// //   // Enhanced agreements with action buttons
// //   const enhancedAgreements = agreements.map(agreement => {
// //     const agreementId = agreement.id || agreement.agreement_id;
// //     const status = agreement.contract_status || 'Pending';
    
// //     return {
// //       ...agreement,
// //       id: agreementId,
// //       contract_status: status,
// //       actions: (
// //         <Box sx={{ 
// //           display: "flex", 
// //           gap: 1, 
// //           flexDirection: 'row',
// //           flexWrap: 'nowrap',
// //           justifyContent: 'center',
// //           alignItems: 'center'
// //         }}>
// //           <Button
// //           variant="outlined"
// //           size="small"
// //           startIcon={<Download />}
// //           onClick={() => handleExportToExcel(agreement)}
// //           disabled={!agreementId}
// //           sx={{ 
// //             whiteSpace: 'nowrap',
// //             borderColor: '#000000',
// //             color: '#000000',
// //             '&:hover': {
// //               borderColor: '#333333',
// //               backgroundColor: 'rgba(0, 0, 0, 0.04)',
// //             }
// //           }}
// //         >
// //           Export
// //         </Button>
// //           <Button
// //             variant="contained"
// //             sx={{ 
// //               whiteSpace: 'nowrap',
// //               bgcolor: '#f5f5f5',
// //               color: '#000',
// //               '&:hover': {
// //                 bgcolor: '#e0e0e0',
// //               }
// //             }}
// //             size="small"
// //             startIcon={<Check />}
// //             onClick={() => handleVerification(agreement, "approve")}
// //             disabled={!agreementId}
// //             // sx={{ whiteSpace: 'nowrap' }}
// //           >
// //             Approve
// //           </Button>
// //           <Button
// //               variant="contained" // Changed from "outlined" to "contained" to match Approve button
// //               size="small"
// //               startIcon={<Download />}
// //               onClick={() => handleExportToExcel(agreement)}
// //               disabled={!agreementId}
// //               sx={{ 
// //                 whiteSpace: 'nowrap',
// //                 backgroundColor: '#f5f5f5', // Light gray background (same as Approve button)
// //                 color: '#d32f2f', // Red text color
// //                 '&:hover': {
// //                   backgroundColor: '#e0e0e0', // Slightly darker gray on hover
// //                   color: '#b71c1c', // Darker red on hover
// //                 },
// //                 '&:disabled': {
// //                   backgroundColor: '#f5f5f5',
// //                   color: '#d32f2f',
// //                   opacity: 0.6,
// //                 }
// //               }}
// //             >
// //               Export
// //             </Button>
// //         </Box>
// //       )
// //     };
// //   });

// //   if (loading) {
// //     return (
// //       <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
// //         <CircularProgress />
// //         <Typography sx={{ ml: 2 }}>Loading pending agreements...</Typography>
// //       </Box>
// //     );
// //   }

// //   return (
// //     <Box sx={{ p: 3 }}>
// //       <Card>
// //         <CardContent>
// //           {error && (
// //             <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError("")}>
// //               {error}
// //             </Alert>
// //           )}

// //           {success && (
// //             <Alert severity="success" sx={{ mb: 2 }} onClose={() => setSuccess("")}>
// //               {success}
// //             </Alert>
// //           )}

// //           {enhancedAgreements.length > 0 ? (
// //             <>
// //               <IPDCFinalTable
// //                 ref={componentRef}
// //                 data={enhancedAgreements}
// //                 setData={setAgreements}
// //                 selectedColumns={selectedColumns}
// //                 title={`Pending Agreements for Approval (${enhancedAgreements.length})`}
// //                 hasAttachment={false}
// //               />
              
// //               <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
// //               <Button
// //                     variant="contained"
// //                     startIcon={<TableChart />}
// //                     onClick={handleExportAllToExcel}
// //                     disabled={enhancedAgreements.length === 0}
// //                     sx={{ 
// //                       whiteSpace: 'nowrap',
// //                       backgroundColor: '#f5f5f5', // Light gray background
// //                       color: '#000000', // Black text for contrast
// //                       '&:hover': {
// //                         backgroundColor: '#e0e0e0', // Slightly darker gray on hover
// //                       },
// //                       '&:disabled': {
// //                         backgroundColor: '#f5f5f5',
// //                         color: '#000000',
// //                         opacity: 0.5,
// //                       }
// //                     }}
// //                   >
// //                     Export All Data ({enhancedAgreements.length} rows)
// //                   </Button>
// //               </Box>
// //             </>
// //           ) : (
// //             !error && (
// //               <Box sx={{ p: 3, textAlign: 'center' }}>
// //                 <Typography variant="h6" color="textSecondary">
// //                   No pending agreements found for approval.
// //                 </Typography>
// //                 <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
// //                   All agreements have been processed or there are no agreements waiting for approval.
// //                 </Typography>
// //               </Box>
// //             )
// //           )}
// //         </CardContent>
// //       </Card>
// //     </Box>
// //   );
// // }
// //************************************************************************************************* */
// import { useEffect, useState, useRef } from "react";
// import { 
//   GetDataFromApiWithParams, 
//   ExecutePostWithParams 
// } from "../../../../services/api/ExecuteApiRequests";
// import IPDCFinalTable from "../../../../components/IPDCFinalTable";
// import { Box, Button, Alert, CircularProgress, Typography, Card, CardContent, Dialog, DialogTitle, DialogContent, DialogActions, TextField } from "@mui/material";
// import { Check, Close, Download, TableChart } from "@mui/icons-material";

// export default function AgreementVerificationPage() {
//   const [agreements, setAgreements] = useState([]);
//   const componentRef = useRef();
//   const [selectedColumns, setSelectedColumns] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const [success, setSuccess] = useState("");

//   // Reject modal state
//   const [rejectModalOpen, setRejectModalOpen] = useState(false);
//   const [rejectingAgreement, setRejectingAgreement] = useState(null);
//   const [rejectJustification, setRejectJustification] = useState("");
//   const [rejectJustificationError, setRejectJustificationError] = useState(false);
//   const [isSubmittingReject, setIsSubmittingReject] = useState(false);

//   useEffect(() => {
//     fetchPendingAgreements();
//   }, []);

//   // Helper function to process JSON fields
//   const processAgreementData = (data) => {
//     if (!data) return data;
    
//     return data.map(item => {
//       const processedItem = { ...item };
      
//       // Handle late_charge_fee JSON object
//       if (processedItem.late_charge_fee && typeof processedItem.late_charge_fee === 'object') {
//         const fee = processedItem.late_charge_fee;
//         processedItem.late_charge_fee = `${fee.fee || 0}${fee.rate_type || '%'}`;
//       }
      
//       // Handle market_destination array
//       if (Array.isArray(processedItem.market_destination)) {
//         processedItem.market_destination = processedItem.market_destination.join(', ');
//       }
      
//       // Handle intl_brands_link array
//       if (Array.isArray(processedItem.intl_brands_link)) {
//         processedItem.intl_brands_link = processedItem.intl_brands_link.join(', ');
//       }
      
//       // Handle any other potential JSON fields
//       if (processedItem.linkage && typeof processedItem.linkage === 'object') {
//         processedItem.linkage = JSON.stringify(processedItem.linkage);
//       }
      
//       return processedItem;
//     });
//   };

//   const fetchPendingAgreements = async () => {
//     try {
//       setLoading(true);
//       setError("");
//       console.log("Fetching pending agreements from API...");
      
//       const resultRow = await GetDataFromApiWithParams("agreements/waiting/approval");
//       console.log("Pending Agreements API Response:", resultRow);
      
//       if (resultRow && Array.isArray(resultRow)) {
//         console.log(`Total pending agreements received: ${resultRow.length}`);
        
//         if (resultRow.length > 0) {
//           console.log("First pending agreement sample:", resultRow[0]);
          
//           // Process the data to convert JSON objects to strings
//           const processedData = processAgreementData(resultRow);
//           setAgreements(processedData);
          
//           // Define columns to show
//           const importantColumns = [
//             'id', 'agreement_id', 'company_name', 'contact_person', 
//             'upin', 'investment_type', 'contract_status',
//             'contract_issued_on', 'contract_period_in_months',
//             'monthly_rent', 'employee_capacity',
//             'production_capacity', 'export_capacity', 'security', 'advance_payment',
//             'tin_no', 'park_name', 'ownership_type', 'payment_mode',
//             'annual_mngmnt_service_fee', 'grace_period_ending_date', 'market_destination', 'disposal_method',
//             'handover_date', 'rehandover_date', 'production_commencement_date', 'late_charge_fee'
//           ];
          
//           // Use important columns that actually exist in the processed data
//           const availableColumns = importantColumns.filter(col => 
//             processedData[0].hasOwnProperty(col)
//           );
          
//           console.log("Columns available for display:", availableColumns);
//           setSelectedColumns([...availableColumns, 'actions']);
//         } else {
//           setAgreements([]);
//           setError("No pending agreements found for approval.");
//         }
//       } else {
//         setError("No agreement data received from API.");
//       }
//     } catch (err) {
//       console.error("Error fetching pending agreements:", err);
//       setError("Error fetching pending agreements: " + (err.message || "Unknown error"));
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Open reject modal with justification form
//   const handleOpenRejectModal = (agreement) => {
//     setRejectingAgreement(agreement);
//     setRejectJustification("");
//     setRejectJustificationError(false);
//     setRejectModalOpen(true);
//   };

//   // Close reject modal
//   const handleCloseRejectModal = () => {
//     setRejectModalOpen(false);
//     setRejectingAgreement(null);
//     setRejectJustification("");
//     setRejectJustificationError(false);
//     setIsSubmittingReject(false);
//   };

//   // Submit rejection with justification
//   const handleSubmitRejection = async () => {
//     // Validate justification
//     if (!rejectJustification.trim()) {
//       setRejectJustificationError(true);
//       return;
//     }

//     setRejectJustificationError(false);
//     setIsSubmittingReject(true);

//     try {
//       const agreementId = rejectingAgreement.id || rejectingAgreement.agreement_id;
//       if (!agreementId) {
//         setError("Cannot reject: Agreement ID is missing");
//         handleCloseRejectModal();
//         return;
//       }

//       // Combine existing description with rejection justification
//       const existingDescription = rejectingAgreement.description || "";
//       const rejectionNote = `[REJECTED By Deputy CEO ON ${new Date().toLocaleString()}] Reason: ${rejectJustification.trim()}`;
//       const updatedDescription = existingDescription 
//         ? `${existingDescription}\n\n${rejectionNote}`
//         : rejectionNote;

//       const updateData = {
//         agreement_id: agreementId,
//         action: "reject",
//         remarks: `Agreement rejected by Deputy CEO. Reason: ${rejectJustification.trim()}`,
//         verified_by: "deputy_ceo",
//         description: updatedDescription
//       };

//       console.log(`Sending reject with justification for agreement:`, agreementId);
//       console.log("Update data:", updateData);
      
//       const response = await ExecutePostWithParams("agreements/approve", updateData);
      
//       if (response) {
//         // Remove the rejected agreement from the list
//         setAgreements(prev => prev.filter(item => 
//           (item.id || item.agreement_id) !== agreementId
//         ));
//         setSuccess(`Agreement successfully rejected! Justification saved to description.`);
//         setError("");
        
//         setTimeout(() => setSuccess(""), 5000);
//         console.log(`Agreement ${agreementId} rejected successfully with justification`);
        
//         // Close modal
//         handleCloseRejectModal();
//       } else {
//         setError("Failed to reject agreement. Server returned no response.");
//         setSuccess("");
//       }
//     } catch (err) {
//       console.error("Rejection error:", err);
//       setError(`Error: ${err.message || "Unknown error during rejection"}`);
//       setSuccess("");
//     } finally {
//       setIsSubmittingReject(false);
//     }
//   };

//   const handleApproval = async (agreement, action) => {
//     try {
//       const agreementId = agreement.id || agreement.agreement_id;
//       if (!agreementId) {
//         setError("Cannot process: Agreement ID is missing");
//         return;
//       }

//       const updateData = {
//         agreement_id: agreementId,
//         action: action,
//         remarks: `Agreement ${action}ed by Deputy CEO`,
//         verified_by: "deputy_ceo",
//       };

//       console.log(`Sending ${action} for agreement:`, agreementId);
//       const response = await ExecutePostWithParams("agreements/approve", updateData);
      
//       if (response) {
//         // Remove the processed agreement from the list
//         setAgreements(prev => prev.filter(item => 
//           (item.id || item.agreement_id) !== agreementId
//         ));
//         setSuccess(`Agreement successfully ${action === "approve" ? "approved" : "processed"}!`);
//         setError("");
//         setTimeout(() => setSuccess(""), 5000);
        
//         console.log(`Agreement ${agreementId} ${action}ed successfully`);
//       } else {
//         setError(`Failed to ${action} agreement. Server returned no response.`);
//         setSuccess("");
//       }
//     } catch (err) {
//       console.error("Approval error:", err);
//       setError(`Error: ${err.message || "Unknown error during processing"}`);
//       setSuccess("");
//     }
//   };

//   const handleExportToExcel = (agreement) => {
//     try {
//       // Create a clean copy without React components
//       const exportData = { ...agreement };
      
//       // Remove actions
//       delete exportData.actions;
      
//       const headers = Object.keys(exportData).filter(key => 
//         typeof exportData[key] !== 'object' || exportData[key] === null
//       );
      
//       const csvHeaders = headers.join(',');
//       const csvRow = headers.map(header => {
//         const value = exportData[header];
//         if (value === null || value === undefined) return '';
//         // Handle values that might contain commas by wrapping in quotes
//         return typeof value === 'string' && value.includes(',') ? `"${value}"` : value;
//       }).join(',');
      
//       const csvContent = `${csvHeaders}\n${csvRow}`;
      
//       const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
//       const link = document.createElement('a');
//       const url = URL.createObjectURL(blob);
      
//       link.setAttribute('href', url);
//       link.setAttribute('download', `agreement_${agreement.id || agreement.agreement_id}_${new Date().toISOString().split('T')[0]}.csv`);
//       link.style.visibility = 'hidden';
      
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
      
//       console.log(`Exported agreement ${agreement.id || agreement.agreement_id} to Excel`);
//     } catch (err) {
//       console.error("Error exporting to Excel:", err);
//       setError("Error exporting agreement data to Excel");
//     }
//   };

//   const handleExportAllToExcel = () => {
//     try {
//       if (enhancedAgreements.length === 0) {
//         setError("No data to export");
//         return;
//       }

//       // Create export data without React components
//       const exportData = enhancedAgreements.map(agreement => {
//         const cleanData = { ...agreement };
//         delete cleanData.actions;
//         return cleanData;
//       });

//       const headers = Object.keys(exportData[0]).filter(key => 
//         typeof exportData[0][key] !== 'object' || exportData[0][key] === null
//       );
      
//       const csvHeaders = headers.join(',');
      
//       const csvRows = exportData.map(item => {
//         return headers.map(header => {
//           const value = item[header];
//           if (value === null || value === undefined) return '';
//           return typeof value === 'string' && value.includes(',') ? `"${value}"` : value;
//         }).join(',');
//       }).join('\n');
      
//       const csvContent = `${csvHeaders}\n${csvRows}`;
      
//       const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
//       const link = document.createElement('a');
//       const url = URL.createObjectURL(blob);
      
//       link.setAttribute('href', url);
//       link.setAttribute('download', `all_pending_agreements_${new Date().toISOString().split('T')[0]}.csv`);
//       link.style.visibility = 'hidden';
      
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
      
//       console.log(`Exported all ${enhancedAgreements.length} agreements to Excel`);
//       setSuccess(`All ${enhancedAgreements.length} agreements exported successfully!`);
//       setTimeout(() => setSuccess(""), 5000);
//     } catch (err) {
//       console.error("Error exporting all to Excel:", err);
//       setError("Error exporting all agreements data to Excel");
//     }
//   };

//   // Enhanced agreements with action buttons
//   const enhancedAgreements = agreements.map(agreement => {
//     const agreementId = agreement.id || agreement.agreement_id;
//     const status = agreement.contract_status || 'Pending';
    
//     return {
//       ...agreement,
//       id: agreementId,
//       contract_status: status,
//       actions: (
//         <Box sx={{ 
//           display: "flex", 
//           gap: 1, 
//           flexDirection: 'row',
//           flexWrap: 'nowrap',
//           justifyContent: 'center',
//           alignItems: 'center'
//         }}>
//           <Button
//             variant="outlined"
//             size="small"
//             startIcon={<Download />}
//             onClick={() => handleExportToExcel(agreement)}
//             disabled={!agreementId}
//             sx={{ 
//               whiteSpace: 'nowrap',
//               borderColor: '#000000',
//               color: '#000000',
//               '&:hover': {
//                 borderColor: '#333333',
//                 backgroundColor: 'rgba(0, 0, 0, 0.04)',
//               }
//             }}
//           >
//             Export
//           </Button>
//           <Button
//             variant="contained"
//             sx={{ 
//               whiteSpace: 'nowrap',
//               bgcolor: '#f5f5f5',
//               color: '#000',
//               '&:hover': {
//                 bgcolor: '#e0e0e0',
//               }
//             }}
//             size="small"
//             startIcon={<Check />}
//             onClick={() => handleApproval(agreement, "approve")}
//             disabled={!agreementId}
//           >
//             Approve
//           </Button>
//           <Button
//             variant="contained"
//             size="small"
//             startIcon={<Close />}
//             onClick={() => handleOpenRejectModal(agreement)}
//             disabled={!agreementId}
//             sx={{ 
//               whiteSpace: 'nowrap',
//               backgroundColor: '#f5f5f5',
//               color: '#d32f2f',
//               '&:hover': {
//                 backgroundColor: '#e0e0e0',
//                 color: '#b71c1c',
//               },
//               '&:disabled': {
//                 backgroundColor: '#f5f5f5',
//                 color: '#d32f2f',
//                 opacity: 0.6,
//               }
//             }}
//           >
//             Reject
//           </Button>
//         </Box>
//       )
//     };
//   });

//   if (loading) {
//     return (
//       <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
//         <CircularProgress />
//         <Typography sx={{ ml: 2 }}>Loading pending agreements...</Typography>
//       </Box>
//     );
//   }

//   return (
//     <Box sx={{ p: 3 }}>
//       <Card>
//         <CardContent>
//           {error && (
//             <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError("")}>
//               {error}
//             </Alert>
//           )}

//           {success && (
//             <Alert severity="success" sx={{ mb: 2 }} onClose={() => setSuccess("")}>
//               {success}
//             </Alert>
//           )}

//           {enhancedAgreements.length > 0 ? (
//             <>
//               <IPDCFinalTable
//                 ref={componentRef}
//                 data={enhancedAgreements}
//                 setData={setAgreements}
//                 selectedColumns={selectedColumns}
//                 title={`Pending Agreements for Approval (${enhancedAgreements.length})`}
//                 hasAttachment={false}
//               />
              
//               <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
//                 <Button
//                   variant="contained"
//                   startIcon={<TableChart />}
//                   onClick={handleExportAllToExcel}
//                   disabled={enhancedAgreements.length === 0}
//                   sx={{ 
//                     whiteSpace: 'nowrap',
//                     backgroundColor: '#f5f5f5',
//                     color: '#000000',
//                     '&:hover': {
//                       backgroundColor: '#e0e0e0',
//                     },
//                     '&:disabled': {
//                       backgroundColor: '#f5f5f5',
//                       color: '#000000',
//                       opacity: 0.5,
//                     }
//                   }}
//                 >
//                   Export All Data ({enhancedAgreements.length} rows)
//                 </Button>
//               </Box>
//             </>
//           ) : (
//             !error && (
//               <Box sx={{ p: 3, textAlign: 'center' }}>
//                 <Typography variant="h6" color="textSecondary">
//                   No pending agreements found for approval.
//                 </Typography>
//                 <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
//                   All agreements have been processed or there are no agreements waiting for approval.
//                 </Typography>
//               </Box>
//             )
//           )}
//         </CardContent>
//       </Card>

//       {/* Reject Justification Modal */}
//       <Dialog 
//         open={rejectModalOpen} 
//         onClose={handleCloseRejectModal}
//         maxWidth="sm"
//         fullWidth
//       >
//         <DialogTitle sx={{ 
//           backgroundColor: '#ffebee', 
//           color: '#c62828',
//           display: 'flex',
//           alignItems: 'center',
//           gap: 1
//         }}>
//           <Close /> Reject Agreement
//         </DialogTitle>
//         <DialogContent sx={{ mt: 2 }}>
//           <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
//             You are about to reject the following agreement:
//           </Typography>
//           <Box sx={{ 
//             p: 2, 
//             backgroundColor: '#f5f5f5', 
//             borderRadius: 1, 
//             mb: 3,
//             wordBreak: 'break-word'
//           }}>
//             <Typography variant="subtitle2" color="primary">
//               Agreement ID: {rejectingAgreement?.agreement_id || rejectingAgreement?.id || 'N/A'}
//             </Typography>
//             <Typography variant="body2">
//               Investor: {rejectingAgreement?.company_name || rejectingAgreement?.investor_name || 'N/A'}
//             </Typography>
//             <Typography variant="body2">
//               Park: {rejectingAgreement?.park_name || rejectingAgreement?.park_id || 'N/A'}
//             </Typography>
//           </Box>
          
//           <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 'bold' }}>
//             Rejection Justification <span style={{ color: 'red' }}>*</span>
//           </Typography>
//           <TextField
//             fullWidth
//             multiline
//             rows={4}
//             placeholder="Please provide a detailed reason for rejecting this agreement..."
//             value={rejectJustification}
//             onChange={(e) => {
//               setRejectJustification(e.target.value);
//               if (e.target.value.trim()) {
//                 setRejectJustificationError(false);
//               }
//             }}
//             error={rejectJustificationError}
//             helperText={rejectJustificationError ? "Justification is required" : "This justification will be saved to the agreement's description field"}
//             variant="outlined"
//             sx={{ mb: 2 }}
//           />
//         </DialogContent>
//         <DialogActions sx={{ p: 2, pt: 0 }}>
//           <Button 
//             onClick={handleCloseRejectModal} 
//             disabled={isSubmittingReject}
//             variant="outlined"
//           >
//             Cancel
//           </Button>
//           <Button 
//             onClick={handleSubmitRejection} 
//             variant="contained"
//             color="error"
//             disabled={isSubmittingReject}
//             startIcon={isSubmittingReject ? <CircularProgress size={20} /> : <Close />}
//           >
//             {isSubmittingReject ? "Rejecting..." : "Confirm Reject"}
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </Box>
//   );
// }
//**************************Approval page with Truncated displosal value */
import { useEffect, useState, useRef } from "react";
import { 
  GetDataFromApiWithParams, 
  ExecutePostWithParams 
} from "../../../../services/api/ExecuteApiRequests";
import IPDCFinalTable from "../../../../components/IPDCFinalTable";
import { Box, Button, Alert, CircularProgress, Typography, Card, CardContent, Dialog, DialogTitle, DialogContent, DialogActions, TextField } from "@mui/material";
import { Check, Close, Download, TableChart } from "@mui/icons-material";

export default function AgreementVerificationPage() {
  const [agreements, setAgreements] = useState([]);
  const componentRef = useRef();
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  // Reject modal state
  const [rejectModalOpen, setRejectModalOpen] = useState(false);
  const [rejectingAgreement, setRejectingAgreement] = useState(null);
  const [rejectJustification, setRejectJustification] = useState("");
  const [rejectJustificationError, setRejectJustificationError] = useState(false);
  const [isSubmittingReject, setIsSubmittingReject] = useState(false);

  useEffect(() => {
    fetchPendingAgreements();
  }, []);

  // Helper function to process JSON fields
  const processAgreementData = (data) => {
    if (!data) return data;
    
    return data.map(item => {
      const processedItem = { ...item };
      
      // Handle late_charge_fee JSON object
      if (processedItem.late_charge_fee && typeof processedItem.late_charge_fee === 'object') {
        const fee = processedItem.late_charge_fee;
        processedItem.late_charge_fee = `${fee.fee || 0}${fee.rate_type || '%'}`;
      }
      
      // Handle market_destination array
      if (Array.isArray(processedItem.market_destination)) {
        processedItem.market_destination = processedItem.market_destination.join(', ');
      }
      
      // Handle intl_brands_link array
      if (Array.isArray(processedItem.intl_brands_link)) {
        processedItem.intl_brands_link = processedItem.intl_brands_link.join(', ');
      }
      
      // Handle any other potential JSON fields
      if (processedItem.linkage && typeof processedItem.linkage === 'object') {
        processedItem.linkage = JSON.stringify(processedItem.linkage);
      }
      
      // Truncate disposal_method field to 7 characters + "..."
      if (processedItem.disposal_method !== undefined && processedItem.disposal_method !== null) {
        const disposalValue = String(processedItem.disposal_method);
        processedItem.disposal_method = disposalValue.length > 7 ? disposalValue.substring(0, 7) + '...' : disposalValue;
      }
      
      return processedItem;
    });
  };

  const fetchPendingAgreements = async () => {
    try {
      setLoading(true);
      setError("");
      console.log("Fetching pending agreements from API...");
      
      const resultRow = await GetDataFromApiWithParams("agreements/waiting/approval");
      console.log("Pending Agreements API Response:", resultRow);
      
      if (resultRow && Array.isArray(resultRow)) {
        console.log(`Total pending agreements received: ${resultRow.length}`);
        
        if (resultRow.length > 0) {
          console.log("First pending agreement sample:", resultRow[0]);
          
          // Process the data to convert JSON objects to strings
          const processedData = processAgreementData(resultRow);
          setAgreements(processedData);
          
          // Define columns to show
          const importantColumns = [
            'id', 'agreement_id', 'company_name', 'contact_person', 
            'upin', 'investment_type', 'contract_status',
            'contract_issued_on', 'contract_period_in_months',
            'monthly_rent', 'employee_capacity',
            'production_capacity', 'export_capacity', 'security', 'advance_payment',
            'tin_no', 'park_name', 'ownership_type', 'payment_mode',
            'annual_mngmnt_service_fee', 'grace_period_ending_date', 'market_destination', 'disposal_method',
            'handover_date', 'rehandover_date', 'production_commencement_date', 'late_charge_fee'
          ];
          
          // Use important columns that actually exist in the processed data
          const availableColumns = importantColumns.filter(col => 
            processedData[0].hasOwnProperty(col)
          );
          
          console.log("Columns available for display:", availableColumns);
          setSelectedColumns([...availableColumns, 'actions']);
        } else {
          setAgreements([]);
          setError("No pending agreements found for approval.");
        }
      } else {
        setError("No agreement data received from API.");
      }
    } catch (err) {
      console.error("Error fetching pending agreements:", err);
      setError("Error fetching pending agreements: " + (err.message || "Unknown error"));
    } finally {
      setLoading(false);
    }
  };

  // Open reject modal with justification form
  const handleOpenRejectModal = (agreement) => {
    setRejectingAgreement(agreement);
    setRejectJustification("");
    setRejectJustificationError(false);
    setRejectModalOpen(true);
  };

  // Close reject modal
  const handleCloseRejectModal = () => {
    setRejectModalOpen(false);
    setRejectingAgreement(null);
    setRejectJustification("");
    setRejectJustificationError(false);
    setIsSubmittingReject(false);
  };

  // Submit rejection with justification
  const handleSubmitRejection = async () => {
    // Validate justification
    if (!rejectJustification.trim()) {
      setRejectJustificationError(true);
      return;
    }

    setRejectJustificationError(false);
    setIsSubmittingReject(true);

    try {
      const agreementId = rejectingAgreement.id || rejectingAgreement.agreement_id;
      if (!agreementId) {
        setError("Cannot reject: Agreement ID is missing");
        handleCloseRejectModal();
        return;
      }

      // Combine existing description with rejection justification
      const existingDescription = rejectingAgreement.description || "";
      const rejectionNote = `[REJECTED By Deputy CEO ON ${new Date().toLocaleString()}] Reason: ${rejectJustification.trim()}`;
      const updatedDescription = existingDescription 
        ? `${existingDescription}\n\n${rejectionNote}`
        : rejectionNote;

      const updateData = {
        agreement_id: agreementId,
        action: "reject",
        remarks: `Agreement rejected by Deputy CEO. Reason: ${rejectJustification.trim()}`,
        verified_by: "deputy_ceo",
        description: updatedDescription
      };

      console.log(`Sending reject with justification for agreement:`, agreementId);
      console.log("Update data:", updateData);
      
      const response = await ExecutePostWithParams("agreements/approve", updateData);
      
      if (response) {
        // Remove the rejected agreement from the list
        setAgreements(prev => prev.filter(item => 
          (item.id || item.agreement_id) !== agreementId
        ));
        setSuccess(`Agreement successfully rejected! Justification saved to description.`);
        setError("");
        
        setTimeout(() => setSuccess(""), 5000);
        console.log(`Agreement ${agreementId} rejected successfully with justification`);
        
        // Close modal
        handleCloseRejectModal();
      } else {
        setError("Failed to reject agreement. Server returned no response.");
        setSuccess("");
      }
    } catch (err) {
      console.error("Rejection error:", err);
      setError(`Error: ${err.message || "Unknown error during rejection"}`);
      setSuccess("");
    } finally {
      setIsSubmittingReject(false);
    }
  };

  const handleApproval = async (agreement, action) => {
    try {
      const agreementId = agreement.id || agreement.agreement_id;
      if (!agreementId) {
        setError("Cannot process: Agreement ID is missing");
        return;
      }

      const updateData = {
        agreement_id: agreementId,
        action: action,
        remarks: `Agreement ${action}ed by Deputy CEO`,
        verified_by: "deputy_ceo",
      };

      console.log(`Sending ${action} for agreement:`, agreementId);
      const response = await ExecutePostWithParams("agreements/approve", updateData);
      
      if (response) {
        // Remove the processed agreement from the list
        setAgreements(prev => prev.filter(item => 
          (item.id || item.agreement_id) !== agreementId
        ));
        setSuccess(`Agreement successfully ${action === "approve" ? "approved" : "processed"}!`);
        setError("");
        setTimeout(() => setSuccess(""), 5000);
        
        console.log(`Agreement ${agreementId} ${action}ed successfully`);
      } else {
        setError(`Failed to ${action} agreement. Server returned no response.`);
        setSuccess("");
      }
    } catch (err) {
      console.error("Approval error:", err);
      setError(`Error: ${err.message || "Unknown error during processing"}`);
      setSuccess("");
    }
  };

  const handleExportToExcel = (agreement) => {
    try {
      // Create a clean copy without React components
      const exportData = { ...agreement };
      
      // Remove actions
      delete exportData.actions;
      
      const headers = Object.keys(exportData).filter(key => 
        typeof exportData[key] !== 'object' || exportData[key] === null
      );
      
      const csvHeaders = headers.join(',');
      const csvRow = headers.map(header => {
        const value = exportData[header];
        if (value === null || value === undefined) return '';
        // Handle values that might contain commas by wrapping in quotes
        return typeof value === 'string' && value.includes(',') ? `"${value}"` : value;
      }).join(',');
      
      const csvContent = `${csvHeaders}\n${csvRow}`;
      
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      
      link.setAttribute('href', url);
      link.setAttribute('download', `agreement_${agreement.id || agreement.agreement_id}_${new Date().toISOString().split('T')[0]}.csv`);
      link.style.visibility = 'hidden';
      
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      console.log(`Exported agreement ${agreement.id || agreement.agreement_id} to Excel`);
    } catch (err) {
      console.error("Error exporting to Excel:", err);
      setError("Error exporting agreement data to Excel");
    }
  };

  const handleExportAllToExcel = () => {
    try {
      if (enhancedAgreements.length === 0) {
        setError("No data to export");
        return;
      }

      // Create export data without React components
      const exportData = enhancedAgreements.map(agreement => {
        const cleanData = { ...agreement };
        delete cleanData.actions;
        return cleanData;
      });

      const headers = Object.keys(exportData[0]).filter(key => 
        typeof exportData[0][key] !== 'object' || exportData[0][key] === null
      );
      
      const csvHeaders = headers.join(',');
      
      const csvRows = exportData.map(item => {
        return headers.map(header => {
          const value = item[header];
          if (value === null || value === undefined) return '';
          return typeof value === 'string' && value.includes(',') ? `"${value}"` : value;
        }).join(',');
      }).join('\n');
      
      const csvContent = `${csvHeaders}\n${csvRows}`;
      
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      
      link.setAttribute('href', url);
      link.setAttribute('download', `all_pending_agreements_${new Date().toISOString().split('T')[0]}.csv`);
      link.style.visibility = 'hidden';
      
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      console.log(`Exported all ${enhancedAgreements.length} agreements to Excel`);
      setSuccess(`All ${enhancedAgreements.length} agreements exported successfully!`);
      setTimeout(() => setSuccess(""), 5000);
    } catch (err) {
      console.error("Error exporting all to Excel:", err);
      setError("Error exporting all agreements data to Excel");
    }
  };

  // Enhanced agreements with action buttons
  const enhancedAgreements = agreements.map(agreement => {
    const agreementId = agreement.id || agreement.agreement_id;
    const status = agreement.contract_status || 'Pending';
    
    return {
      ...agreement,
      id: agreementId,
      contract_status: status,
      actions: (
        <Box sx={{ 
          display: "flex", 
          gap: 1, 
          flexDirection: 'row',
          flexWrap: 'nowrap',
          justifyContent: 'center',
          alignItems: 'center'
        }}>
          <Button
            variant="outlined"
            size="small"
            startIcon={<Download />}
            onClick={() => handleExportToExcel(agreement)}
            disabled={!agreementId}
            sx={{ 
              whiteSpace: 'nowrap',
              borderColor: '#000000',
              color: '#000000',
              '&:hover': {
                borderColor: '#333333',
                backgroundColor: 'rgba(0, 0, 0, 0.04)',
              }
            }}
          >
            Export
          </Button>
          <Button
            variant="contained"
            sx={{ 
              whiteSpace: 'nowrap',
              bgcolor: '#f5f5f5',
              color: '#000',
              '&:hover': {
                bgcolor: '#e0e0e0',
              }
            }}
            size="small"
            startIcon={<Check />}
            onClick={() => handleApproval(agreement, "approve")}
            disabled={!agreementId}
          >
            Approve
          </Button>
          <Button
            variant="contained"
            size="small"
            startIcon={<Close />}
            onClick={() => handleOpenRejectModal(agreement)}
            disabled={!agreementId}
            sx={{ 
              whiteSpace: 'nowrap',
              backgroundColor: '#f5f5f5',
              color: '#d32f2f',
              '&:hover': {
                backgroundColor: '#e0e0e0',
                color: '#b71c1c',
              },
              '&:disabled': {
                backgroundColor: '#f5f5f5',
                color: '#d32f2f',
                opacity: 0.6,
              }
            }}
          >
            Reject
          </Button>
        </Box>
      )
    };
  });

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
        <CircularProgress />
        <Typography sx={{ ml: 2 }}>Loading pending agreements...</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 3 }}>
      <Card>
        <CardContent>
          {error && (
            <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError("")}>
              {error}
            </Alert>
          )}

          {success && (
            <Alert severity="success" sx={{ mb: 2 }} onClose={() => setSuccess("")}>
              {success}
            </Alert>
          )}

          {enhancedAgreements.length > 0 ? (
            <>
              <IPDCFinalTable
                ref={componentRef}
                data={enhancedAgreements}
                setData={setAgreements}
                selectedColumns={selectedColumns}
                title={`Pending Agreements for Approval (${enhancedAgreements.length})`}
                hasAttachment={false}
              />
              
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                <Button
                  variant="contained"
                  startIcon={<TableChart />}
                  onClick={handleExportAllToExcel}
                  disabled={enhancedAgreements.length === 0}
                  sx={{ 
                    whiteSpace: 'nowrap',
                    backgroundColor: '#f5f5f5',
                    color: '#000000',
                    '&:hover': {
                      backgroundColor: '#e0e0e0',
                    },
                    '&:disabled': {
                      backgroundColor: '#f5f5f5',
                      color: '#000000',
                      opacity: 0.5,
                    }
                  }}
                >
                  Export All Data ({enhancedAgreements.length} rows)
                </Button>
              </Box>
            </>
          ) : (
            !error && (
              <Box sx={{ p: 3, textAlign: 'center' }}>
                <Typography variant="h6" color="textSecondary">
                  No pending agreements found for approval.
                </Typography>
                <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
                  All agreements have been processed or there are no agreements waiting for approval.
                </Typography>
              </Box>
            )
          )}
        </CardContent>
      </Card>

      {/* Reject Justification Modal */}
      <Dialog 
        open={rejectModalOpen} 
        onClose={handleCloseRejectModal}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ 
          backgroundColor: '#ffebee', 
          color: '#c62828',
          display: 'flex',
          alignItems: 'center',
          gap: 1
        }}>
          <Close /> Reject Agreement
        </DialogTitle>
        <DialogContent sx={{ mt: 2 }}>
          <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
            You are about to reject the following agreement:
          </Typography>
          <Box sx={{ 
            p: 2, 
            backgroundColor: '#f5f5f5', 
            borderRadius: 1, 
            mb: 3,
            wordBreak: 'break-word'
          }}>
            <Typography variant="subtitle2" color="primary">
              Agreement ID: {rejectingAgreement?.agreement_id || rejectingAgreement?.id || 'N/A'}
            </Typography>
            <Typography variant="body2">
              Investor: {rejectingAgreement?.company_name || rejectingAgreement?.investor_name || 'N/A'}
            </Typography>
            <Typography variant="body2">
              Park: {rejectingAgreement?.park_name || rejectingAgreement?.park_id || 'N/A'}
            </Typography>
          </Box>
          
          <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 'bold' }}>
            Rejection Justification <span style={{ color: 'red' }}>*</span>
          </Typography>
          <TextField
            fullWidth
            multiline
            rows={4}
            placeholder="Please provide a detailed reason for rejecting this agreement..."
            value={rejectJustification}
            onChange={(e) => {
              setRejectJustification(e.target.value);
              if (e.target.value.trim()) {
                setRejectJustificationError(false);
              }
            }}
            error={rejectJustificationError}
            helperText={rejectJustificationError ? "Justification is required" : "This justification will be saved to the agreement's description field"}
            variant="outlined"
            sx={{ mb: 2 }}
          />
        </DialogContent>
        <DialogActions sx={{ p: 2, pt: 0 }}>
          <Button 
            onClick={handleCloseRejectModal} 
            disabled={isSubmittingReject}
            variant="outlined"
          >
            Cancel
          </Button>
          <Button 
            onClick={handleSubmitRejection} 
            variant="contained"
            color="error"
            disabled={isSubmittingReject}
            startIcon={isSubmittingReject ? <CircularProgress size={20} /> : <Close />}
          >
            {isSubmittingReject ? "Rejecting..." : "Confirm Reject"}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}